import { render, staticRenderFns } from "./BaseFooterFrame.vue?vue&type=template&id=51639e02&"
import script from "./BaseFooterFrame.vue?vue&type=script&lang=js&"
export * from "./BaseFooterFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports